import { useState } from 'react';
import Icon from '../../../components/AppIcon';

const ProfileHeader = ({ userData, isEditing, onAvatarChange }) => {
  const [avatarPreview, setAvatarPreview] = useState(userData?.avatar);

  const handleAvatarUpload = (e) => {
    const file = e?.target?.files?.[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setAvatarPreview(reader?.result);
        onAvatarChange?.(file);
      };
      reader?.readAsDataURL(file);
    }
  };

  const tierColors = {
    'Explorador': 'var(--color-muted-foreground)',
    'Emprendedor': 'var(--color-accent)',
    'Elite': 'var(--color-primary)'
  };

  return (
    <div className="bg-card rounded-lg border border-border p-6 shadow-card">
      <div className="flex flex-col sm:flex-row items-center gap-6">
        {/* Avatar */}
        <div className="relative">
          <div className="w-24 h-24 rounded-full bg-muted flex items-center justify-center overflow-hidden">
            {avatarPreview ? (
              <img src={avatarPreview} alt="Avatar" className="w-full h-full object-cover" />
            ) : (
              <Icon name="User" size={48} color="var(--color-muted-foreground)" />
            )}
          </div>
          {isEditing && (
            <label className="absolute bottom-0 right-0 w-8 h-8 bg-primary rounded-full flex items-center justify-center cursor-pointer hover:bg-primary/90 transition-colors">
              <Icon name="Camera" size={16} color="white" />
              <input
                type="file"
                accept="image/*"
                onChange={handleAvatarUpload}
                className="hidden"
              />
            </label>
          )}
        </div>

        {/* User Info */}
        <div className="flex-1 text-center sm:text-left">
          <h2 className="text-2xl font-bold text-foreground mb-2">{userData?.fullName}</h2>
          <div className="flex flex-col sm:flex-row items-center gap-3">
            <div className="flex items-center gap-2 px-3 py-1 bg-primary/10 rounded-full">
              <Icon name="Crown" size={16} color={tierColors?.[userData?.membershipTier]} />
              <span className="text-sm font-semibold" style={{ color: tierColors?.[userData?.membershipTier] }}>
                {userData?.membershipTier}
              </span>
            </div>
            <span className="text-sm text-muted-foreground">{userData?.email}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfileHeader;